import { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { sidebarItems } from "./SidebarItems";
import "./styles/styles.css";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "Constants/AllRoutes";

export const Sidebar = ({ collapsed }) => {
  const { Sider } = Layout;
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState("0");

  useEffect(() => {
    const path = location.pathname;
    const item = sidebarItems.find((item) => item.target === path);
    if (item) {
      setSelectedItem(item.key);
    }
  }, [location.pathname]);

  const handleMenuClick = (e) => {
    setSelectedItem(e.key);
    let selectedItem = null;
    let target = ROUTES.MY_CALENDAR;
    for (const item of sidebarItems) {
      if (item.key === e.key) {
        selectedItem = item;
        target = item.target || ROUTES.MY_CALENDAR;
        break;
      }
      if (item.children) {
        const child = item.children.find((child) => child.key === e.key);
        if (child) {
          selectedItem = child;
          target = child.target || ROUTES.MY_CALENDAR;
          break;
        }
      }
    }
    if (selectedItem) {
      navigate(target || ROUTES.MY_CALENDAR);
    }
  };

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      className="sider-container"
      style={{
        position: "sticky",
        insetInlineStart: "0",
        top: "0",
        left: "0",
        bottom: "0",
        scrollbarWidth: "thin",
        scrollbarGutter: "stable",
      }}
    >
      <div className="logo-container">
        <div>
          <img
            src={
              "https://stagingonegrad.blob.core.windows.net/fe-assets/logo.png"
            }
            alt="Logo"
            className="logo-image"
            style={{ width: collapsed ? "5em" : "10em" }}
          />
        </div>
      </div>
      <Menu
        className="sidebar-menu"
        theme="light"
        mode="inline"
        defaultSelectedKeys={[selectedItem]}
        selectedKeys={[selectedItem]}
        items={sidebarItems}
        onClick={handleMenuClick}
        style={{
          border: "none",
        }}
      />
    </Sider>
  );
};
